import dayjs from "@/lib/helpers/dayjs";
import { NoteDetail } from "@/core/types";
import { testLocator } from "@/lib/helpers/test-locator";
import { useMatchSupervisor } from "@/features/cosignature/hooks/useMatchSupervisor";

import { NoteSignature } from "../../(signature)/NoteSignature";

import "react-loading-skeleton/dist/skeleton.css";

type SignatureProps = {
  note: NoteDetail;
};

export function SignatureList({ note }: SignatureProps) {
  const {
    completed_date_time,
    cosigned_by,
    provider_cp_credentials,
    provider_practice,
    signature,
  } = note;

  const { isLoading, supervisor } = useMatchSupervisor(cosigned_by);

  return (
    <footer {...testLocator("note-footer")}>
      <ul className="tw:flex tw:flex-wrap tw:items-start tw:justify-between tw:gap-4">
        {signature && (
          <NoteSignature isProvider label="Signature">
            {signature}
            {provider_cp_credentials ? `, ${provider_cp_credentials}` : ""}
          </NoteSignature>
        )}

        {cosigned_by && (isLoading || supervisor) && (
          <NoteSignature isLoading={isLoading} isProvider label="Co-signature">
            {supervisor?.name}
          </NoteSignature>
        )}

        {completed_date_time && (
          <NoteSignature label="Signature Date">
            {dayjs(completed_date_time).format("MM/DD/YYYY")}
          </NoteSignature>
        )}

        {provider_practice && (
          <NoteSignature label="Provider Practice">{provider_practice}</NoteSignature>
        )}
      </ul>
    </footer>
  );
}
